module.exports = __webpack_public_path__ + "img/img-1.11f21658.png";